<template>
  <div>
    <EmployeeEdit ref="EmployeeEdit1" @bindGrid="bindTable" :showremove="false"></EmployeeEdit>
    <el-card class="box-card" v-for="(item,index) in shopList" :key="index">
        <div slot="header" class="clearfix">
          <span>{{item.dname}}</span>
          <el-button  style="float: right; padding: 3px 0;width:60px;height:28px" size="mini" type="success" plain @click="addRow(item)">新增</el-button>
        </div>
        <el-table
          :data="item.staffList"
          stripe :show-header="false"
          border
          style="width: 100%;">
          <el-table-column
            width="50"
            label="序号"
            align="center">
            <template slot-scope="scope">
              {{1+scope.$index}}
            </template>
          </el-table-column>
          <el-table-column
            prop="uname"
            label="姓名"
            align="left"
            width="100">
          </el-table-column>
          <el-table-column
            prop="mobile"
            label="手机号"
            align="center"
            width="140">
          </el-table-column>
          <el-table-column
            prop="post"
            label="岗位"
            align="left" header-align="center">
          </el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="danger" v-if="scope.row.uguid!=userInfoModel.uguid"
                @click="handleDelete(item.staffList,scope.$index, scope.row)">删除
              </el-button>
              <el-button
                size="mini" v-if="scope.row.uguid!=userInfoModel.uguid"
                @click="handleEdit(scope.$index, scope.row)">修改
              </el-button>
            </template>
          </el-table-column>
        </el-table>
    </el-card>
  </div>
</template>

<script>
  import {listDept} from '@/api/sysmanage/register';
  import {getListData,removeEmp} from '@/api/set/employee'
  import EmployeeEdit from '@/components/set/employee/EmployeeEdit';

export default {
  data() {
    return {
      userInfoModel:{},
      shopList: []
    }
  },
  methods: {
    handleEdit(index,row){
      this.$refs.EmployeeEdit1.initData(row.uguid)
      this.$refs.EmployeeEdit1.show(row.dserial,row.dname)
    },
    handleDelete(tableData, index, row) {
      this.$confirm('是否确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          removeEmp({uguid:row.uguid}).then(response=>{
            tableData.splice(index, 1);
          })
        })
    },
    addRow(row) {
      this.$refs.EmployeeEdit1.initForm()
      this.$refs.EmployeeEdit1.show(row.dserial,row.dname)
    },
    finishFn(callback) {
      if (callback) {
        callback(true);
      }
    },
    bindTable(){
      //取部门
      listDept().then(response => {
        if (response.data.code == 0) {//有数据返回的
          //staffList
          this.shopList=[{dname:document.title,dserial:'0001',staffList:[]}];
          for(let i in response.data.obj) {
            this.shopList.push({
              dname: response.data.obj[i].dname,
              dserial: response.data.obj[i].serialnum,
              staffList: []
            })
          }

          //人员+岗位
          getListData({
            offset: 0,
            limit: 1000,
            search: '',
            fdpath: '',
            status: '',
            showpost:1,
          }).then(response => {
            var users = response.data.obj.rows;
            for (let j in this.shopList) {
              for (let i in users) {
                if (this.shopList[j].dserial == users[i].dserial) {
                  this.shopList[j].staffList.push(users[i]);
                }
              }
            }
            console.log(this.shopList)
          }).catch((error) => {
            console.log(error)
          });
        }
      });
    }
  },
  mounted() {//第一次加载，取公司信息
    this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"));
    this.bindTable();
  },
  components: {
    EmployeeEdit,
  }
}
</script>

<style scoped>

  .box-card {
    width: 100%;
    margin-left: 0px;
    margin-bottom: 25px;
    min-height: 280px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  .clearfix span{
    float:left;
    font-weight:600;
    font-size:14px;
  }
</style>



// WEBPACK FOOTER //
// src/views/childComp/StaffMaintain.vue